import React from "react";
import { Badge } from "@/components/ui/badge";

const STATUS_CLS = {
  open: "bg-sky-100 text-sky-800 border-sky-200",
  partial: "bg-amber-100 text-amber-800 border-amber-200",
  received: "bg-emerald-100 text-emerald-800 border-emerald-200",
  cancelled: "bg-slate-200 text-slate-600 border-slate-300",
};

export const POStatus = ({ status }) => (
  <Badge className={`${STATUS_CLS[status] || STATUS_CLS.open} uppercase text-xs hover:opacity-90`}>{status}</Badge>
);
